import styled from 'styled-components';

export const StyledChatButtonWrapper = styled.div`
  z-index: 3;
  right: 24px;
  bottom: 20px;
  position: fixed;
`;
